import { IconButton, Menu, MenuItem, Stack, Typography } from "@mui/material";
import EmailIcon from "src/assets/svg-icons/email.svg";
import CloseIcon from "src/assets/svg-icons/close_trans.svg";
import WhatsAppIcon from "src/assets/svg-icons/whatsapp.svg";
import CalcIcon from "src/assets/svg-icons/logo.svg";
import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { notificationsState } from "src/store/notifications";
import DownloadIcon from "src/assets/svg-icons/download.svg";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ConfirmPopup } from "src/shared/components/confirm-popup";
import { specificBranchHasPermission } from "src/utils";
import { InventoryPermissions } from "src/constants/permissions";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { useSendPoMutation } from "src/api/inventory/reorder";
import {
  useResubmitInvoiceMutation,
  useReturnInvoiceMutation,
} from "src/api/sales/invoices";
import PaidOutlinedIcon from "@mui/icons-material/PaidOutlined";
import AddInvoicePaymentPopup from "../../pay-popup";
import ReasonPopup from "../../reaosn-popup";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";

interface IAction {
  row: any;
  refetch: Function;
}

const TableActions = (props: IAction) => {
  const { row, refetch } = props;
  const { id, invoice_status, send_method, branch, type, zatca } = row;
  const { t } = useTranslation("inventory");
  const { t: generalT } = useTranslation("general");
  const { t: salesT } = useTranslation("addSales");
  const navigate = useNavigate();
  const [notifications, setNotifications] = useRecoilState(notificationsState);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [actionType, setActionType] = useState<string>();
  const [openPay, setOpenPay] = useState(false);
  const [openReason, setOpenReason] = useState(false);

  const isCancelled = invoice_status === "cancelled";
  const isSubmitted = invoice_status === "submitted";
  const isInvoice = type === "invoice";
  const isCreditNote = type === "credit_note";
  const isRejected = zatca?.status === "rejected";

  // APIS
  const { mutate, data, isPending, status, error } = useReturnInvoiceMutation();
  const {
    mutate: mutateResubmit,
    data: resubmitData,
    isPending: isPendingResubmit,
    status: resubmitStatus,
    error: resubmitError,
  } = useResubmitInvoiceMutation();
  const {
    mutate: mutateSend,
    error: errorSend,
    status: statusSend,
    isPending: isPendingSend,
  } = useSendPoMutation();

  //permissions
  const viewPoPermission = specificBranchHasPermission(
    InventoryPermissions.viewPoReq,
    branch?.id,
  );
  const sendPoPermission = specificBranchHasPermission(
    InventoryPermissions.sendPoReq,
    branch?.id,
  );
  const cancelPoPermission = specificBranchHasPermission(
    InventoryPermissions.cancelPoReq,
    branch?.id,
  );

  const handleOpenConfirm = (type: string) => {
    setActionType(type);
    setOpenConfirm(true);
  };

  const handleCloseConfirm = () => setOpenConfirm(false);

  const handleClick = (
    event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
  ) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenPay = () => setOpenPay(true);
  const handleClosePay = () => setOpenPay(false);

  const handleOpenReason = () => setOpenReason(true);
  const handleCloseReason = () => setOpenReason(false);

  const navigateToPoDetails = () => {
    navigate(`/sales/invoices/${id}`);
  };

  const handleConfirm = () => {
    if (actionType === "return") {
      mutate({ id });
    } else if (actionType === "resubmit") {
      mutateResubmit(
        { id },
        {
          onSuccess: () => {
            navigate(`/sales/invoices/${resubmitData?.data?.sale_invoice_id}`);
          },
          onError: () => {
            setNotifications([
              ...notifications,
              {
                type: "error",
                message:
                  resubmitError?.data?.errors?.[0].value || t("somethingWrong"),
              },
            ]);
          },
        },
      );
    } else if (actionType === "sendApp") {
      mutateSend({
        id,
        send_method: send_method === "app" ? "not_sent" : "app",
      });
    } else if (actionType === "sendEmail") {
      mutateSend({
        id,
        send_method: send_method === "email" ? "not_sent" : "email",
      });
    } else if (actionType === "cancelAndCopy") {
      navigate(`/sales/invoices/${id}/copy`);
    }
  };

  useEffect(() => {
    if (status === "success") {
      refetch();
      handleCloseConfirm();
      navigate(`/sales/invoices/${data?.data?.sale_invoice_id}`);
    } else if (status === "error") {
      setNotifications([
        ...notifications,
        {
          type: "error",
          message: error?.data?.errors?.[0].value || t("somethingWrong"),
        },
      ]);
    }
  }, [status]);

  useEffect(() => {
    if (statusSend === "success") {
      refetch();
      handleCloseConfirm();
      setNotifications([
        ...notifications,
        {
          type: "success",
          message: generalT("done"),
        },
      ]);
    } else if (statusSend === "error") {
      setNotifications([
        ...notifications,
        {
          type: "error",
          message: errorSend?.data.errors[0].value || t("somethingWrong"),
        },
      ]);
    }
  }, [statusSend]);

  return (
    <Stack direction={"row"} spacing={"12px"} justifyContent={"center"}>
      <IconButton size="small" onClick={(e) => handleClick(e)}>
        <MoreVertIcon />
      </IconButton>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {true && (
          <MenuItem
            // onClick={(e) => handleOpenConfirm("sendEmail")}
            sx={{ gap: 1 }}
            disabled={isCancelled}
          >
            <img width={17} src={EmailIcon} alt="" />
            <Typography
              color={"#1D2939"}
              fontSize={"16px"}
              textTransform={"capitalize"}
            >
              {t("sendEmail")}
            </Typography>
          </MenuItem>
        )}
        {true && (
          <MenuItem
            // onClick={(e) => handleOpenConfirm("sendApp")}
            sx={{ gap: 1 }}
            disabled={isCancelled}
          >
            <img width={16} src={CalcIcon} alt="" />
            <Typography
              color={"#1D2939"}
              fontSize={"16px"}
              textTransform={"capitalize"}
            >
              {t("sendApp")}
            </Typography>
          </MenuItem>
        )}

        <MenuItem sx={{ gap: 1 }} disabled={isCancelled}>
          <img width={15} src={WhatsAppIcon} alt="" />
          <Typography
            color={"#1D2939"}
            fontSize={"16px"}
            textTransform={"capitalize"}
          >
            {t("shareWhatsApp")}
          </Typography>
        </MenuItem>

        <MenuItem onClick={navigateToPoDetails} sx={{ gap: 1 }}>
          <VisibilityOutlinedIcon sx={{ fontSize: "16px" }} />
          <Typography
            color={"#1D2939"}
            fontSize={"16px"}
            textTransform={"capitalize"}
          >
            {t("details")}
          </Typography>
        </MenuItem>

        {true && (
          <MenuItem onClick={(e) => {}} sx={{ gap: 1 }}>
            <img src={DownloadIcon} alt="" />
            <Typography
              color={"#1D2939"}
              fontSize={"16px"}
              textTransform={"capitalize"}
            >
              {generalT("download")}
            </Typography>
          </MenuItem>
        )}

        {!isCancelled && isInvoice && isSubmitted && (
          <MenuItem
            sx={{ gap: 1 }}
            onClick={(e) => handleOpenConfirm("return")}
          >
            <img width={17} src={CloseIcon} alt="" />
            <Typography
              color={"#1D2939"}
              fontSize={"16px"}
              textTransform={"capitalize"}
            >
              {salesT("return")}
            </Typography>
          </MenuItem>
        )}

        {row?.payment_status !== "Paid" && row.invoice_status !== "draft" && !isCancelled && (
          <MenuItem onClick={handleOpenPay} sx={{ gap: 1 }}>
            <PaidOutlinedIcon sx={{ fontSize: "16px" }} />
            <Typography
              color={"#1D2939"}
              fontSize={"16px"}
              textTransform={"capitalize"}
            >
              {isCreditNote ? generalT("refund") : `${t("pay")}!`}
            </Typography>
          </MenuItem>
        )}

        {!!row?.zatca?.reason && (
          <MenuItem onClick={handleOpenReason} sx={{ gap: 1 }}>
            <InfoOutlinedIcon sx={{ fontSize: "16px" }} />
            <Typography
              color={"#1D2939"}
              fontSize={"16px"}
              textTransform={"capitalize"}
            >
              {generalT("reason")}
            </Typography>
          </MenuItem>
        )}

        {isRejected && (
          <MenuItem
            sx={{ gap: 1 }}
            onClick={(e) => handleOpenConfirm("resubmit")}
          >
            <img width={17} src={CloseIcon} alt="" />
            <Typography
              color={"#1D2939"}
              fontSize={"16px"}
              textTransform={"capitalize"}
            >
              {salesT("resubmit")}
            </Typography>
          </MenuItem>
        )}
      </Menu>

      {/* payment popup */}
      {openPay && (
        <AddInvoicePaymentPopup
          open={openPay}
          handleClose={handleClosePay}
          refetch={refetch}
          row={row}
        />
      )}

      {/* reason popup */}
      {openReason && (
        <ReasonPopup
          open={openReason}
          handleClose={handleCloseReason}
          reason={row?.zatca?.reason ?? ""}
        />
      )}

      {/* confirm delete popup */}
      <ConfirmPopup
        open={openConfirm}
        item={""}
        handleClose={handleCloseConfirm}
        handleConfirm={handleConfirm}
        isPending={isPending || isPendingSend || isPendingResubmit}
        title={
          actionType === "sendApp"
            ? t("sendApp")
            : actionType === "sendEmail"
              ? t("sendEmail")
              : actionType === "return"
                ? salesT("return")
                : actionType === "resubmit"
                  ? salesT("resubmit")
                  : t("cancel")
        }
        subtitle={generalT("areYouSureToConfirm")}
        confirmBtnText={generalT("confirm")}
        noIcon
      />
    </Stack>
  );
};
export default TableActions;
